import { apiFetch } from "../utils/apiFetch";
import { API_BASE_CLIENT as API_BASE } from "../config/vars";

async function parseResponseError(response, fallbackMessage) {
    const errorData = await response.json().catch(() => ({}));
    throw new Error(errorData.detail || fallbackMessage);
}

export const fetchClientSensorAccess = async () => {
    const response = await apiFetch(`${API_BASE}/sensors/client/access`);
    if (!response.ok) {
        await parseResponseError(response, "Не вдалося визначити доступ до сенсорів");
    }
    return await response.json();
};

export const listClientSensors = async () => {
    const response = await apiFetch(`${API_BASE}/sensors/client/devices`);
    if (!response.ok) {
        await parseResponseError(response, "Не вдалося завантажити сенсори");
    }
    return await response.json();
};

export const claimClientSensor = async (payload) => {
    const response = await apiFetch(`${API_BASE}/sensors/client/devices/claim`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(payload),
    });
    if (!response.ok) {
        await parseResponseError(response, "Не вдалося прив'язати сенсор");
    }
    return await response.json();
};

export const updateClientSensor = async (sensorId, payload) => {
    const response = await apiFetch(`${API_BASE}/sensors/client/devices/${encodeURIComponent(sensorId)}`, {
        method: "PUT",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(payload),
    });
    if (!response.ok) {
        await parseResponseError(response, "Не вдалося оновити сенсор");
    }
    return await response.json();
};

export const listClientSensorShares = async (sensorId) => {
    const response = await apiFetch(`${API_BASE}/sensors/client/devices/${encodeURIComponent(sensorId)}/shares`);
    if (!response.ok) {
        await parseResponseError(response, "Не вдалося завантажити спільний доступ");
    }
    return await response.json();
};

export const createClientSensorShare = async (sensorId, payload) => {
    const response = await apiFetch(`${API_BASE}/sensors/client/devices/${encodeURIComponent(sensorId)}/shares`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(payload),
    });
    if (!response.ok) {
        await parseResponseError(response, "Не вдалося поділитися сенсором");
    }
    return await response.json();
};

export const deleteClientSensorShare = async (sensorId, shareId) => {
    const response = await apiFetch(
        `${API_BASE}/sensors/client/devices/${encodeURIComponent(sensorId)}/shares/${encodeURIComponent(shareId)}`,
        { method: "DELETE" }
    );
    if (!response.ok) {
        await parseResponseError(response, "Не вдалося скасувати спільний доступ");
    }
    return await response.json();
};

export const detachClientSensor = async (sensorId) => {
    const response = await apiFetch(`${API_BASE}/sensors/client/devices/${encodeURIComponent(sensorId)}`, {
        method: "DELETE",
    });
    if (!response.ok) {
        await parseResponseError(response, "Не вдалося прибрати сенсор зі списку");
    }
    return await response.json();
};

export const fetchClientSensorEvents = async (sensorId, options = {}) => {
    const params = new URLSearchParams();
    params.set("limit", String(options.limit ?? 100));
    if (options.dateFrom) params.set("date_from", options.dateFrom);
    if (options.dateTo) params.set("date_to", options.dateTo);

    const response = await apiFetch(
        `${API_BASE}/sensors/client/devices/${encodeURIComponent(sensorId)}/events?${params.toString()}`
    );
    if (!response.ok) {
        await parseResponseError(response, "Не вдалося завантажити історію сенсора");
    }
    return await response.json();
};

export const fetchClientSensorProvisioning = async (sensorId) => {
    const response = await apiFetch(`${API_BASE}/sensors/client/devices/${encodeURIComponent(sensorId)}/provisioning`);
    if (!response.ok) {
        await parseResponseError(response, "Не вдалося отримати дані для налаштування сенсора");
    }
    return await response.json();
};